<template>
  <div class="fastcopy-promotion-page">
    <!-- Header -->
    <el-header class="header">
      <div class="header-content">
        <div class="logo">
                  <img src="../assets/fastcopy64-2.png" class="logo-icon" alt="FastCopy Logo">
                  <span class="logo-text">FastCopy</span>
                </div>
        <el-menu 
          mode="horizontal" 
          class="nav-menu" 
          background-color="transparent" 
          text-color="#1890ff"
          active-text-color="#1890ff"
          :default-active="activeMenu"
          @select="handleMenuSelect"
          :ellipsis="false"
        >
          <el-menu-item index="/fastcopy" :style="{ color: '#666' }">首页</el-menu-item>
          <el-menu-item index="/order-query" :style="{ color: '#666' }">订单查询</el-menu-item>
          <el-menu-item index="/feedback" :style="{ color: '#666' }">意见反馈</el-menu-item>
        </el-menu>
      </div>
    </el-header>

    <!-- Hero Section -->
    <div class="main-banner">
      <div class="container">
        <div class="hero-content">
          <div class="hero-text">
            <div id="comment-container" class="animate">
              <div id="comment1"><strong>FastCopy</strong> 是全球最快的文件复制工具，采用先进的传输算法，速度比系统自带复制功能快 10-20 倍。支持大文件、批量文件的高速传输，是提升工作效率的必备工具。</div>
            </div>
            <div class="hero-action-row">
              <el-button 
                type="primary" 
                size="large" 
                class="cta-btn download-speed-btn" 
                @click="downloadFastCopy"
                :aria-label="'下载 FastCopy 最新版本，当前下载次数：' + downloadCount.toLocaleString()"
              >
                <el-icon><Download /></el-icon>
                <span class="btn-text">立即下载 FastCopy</span>
              </el-button>
              <div class="download-counter">
                <span class="counter-label">累计下载 </span>
                <span class="counter-number">{{ downloadCount.toLocaleString() }}</span>
                <span class="counter-label">次</span>
                <span class="counter-animation" :class="{ 'animate': isAnimating }">+1</span>
              </div>
            </div>
            <div class="system-requirements">
              <img src="../assets/Windows.png" alt="Windows">
              <span>支持系统：Windows XP/7/8/10/11</span>
            </div>
            <div class="download-benefits-info">
              <el-icon color="#409EFF"><Lightning /></el-icon>
              <span>绿色免安装</span>
              <el-icon color="#E6A23C"><Star /></el-icon>
              <span>无广告</span>
              <el-icon color="#67C23A"><Refresh /></el-icon>
              <span>持续更新</span>
            </div>
          </div>
          <img 
            src="../assets/fc_sample_mini_c2.png" 
            alt="FastCopy 预览图" 
            class="hero-image-big"
          >
        </div>
      </div>
    </div>

    <!-- Feature Block -->
    <div class="featureblock">
      <div class="container">
        <div class="panel-container" style="margin-bottom:30px">
          <!-- Feature 1: Ultra Fast Speed -->
          <div class="panel thirds impact">
            <div class="feature-icon-wrapper blue">
              <el-icon size="32"><TrendCharts /></el-icon>
            </div>
            <h2>超快传输速度</h2>
            <p>FastCopy 采用先进的 I/O 缓冲技术和多线程传输，速度比 Windows 系统自带复制功能快 10-20 倍。特别适合传输大文件、电影、ISO 镜像等，节省大量时间。</p>
          </div>

          <!-- Feature 2: Smart File Management -->
          <div class="panel thirds impact">
            <div class="feature-icon-wrapper green">
              <el-icon size="32"><FolderOpened /></el-icon>
            </div>
            <h2>智能文件管理</h2>
            <p>FastCopy 具备智能冲突处理机制，自动检测重复文件，避免重复传输。支持文件过滤规则，可按名称、大小、日期等条件筛选文件，让文件管理更加精准高效。</p>
          </div>

          <!-- Feature 3: Resume Transfer -->
          <div class="panel thirds impact">
            <div class="feature-icon-wrapper orange">
              <el-icon size="32"><Refresh /></el-icon>
            </div>
            <h2>断点续传功能</h2>
            <p>FastCopy 支持断点续传功能，即使传输过程中意外中断，也能从断点处继续传输，无需重新开始。支持暂停/恢复操作，方便用户灵活控制传输过程。</p>
          </div>
        </div>

        <div class="panel-container" style="margin-bottom:30px">
          <!-- Feature 4: Multiple Operations -->
          <div class="panel thirds impact">
            <div class="feature-icon-wrapper purple">
              <el-icon size="32"><DocumentCopy /></el-icon>
            </div>
            <h2>多种传输模式</h2>
            <p>FastCopy 支持复制、移动、删除、校验等多种文件操作模式。内置 MD5/SHA1 文件校验功能，确保文件完整性。支持计划任务，自动化文件处理流程。</p>
          </div>

          <!-- Feature 5: Network Transfer -->
          <div class="panel thirds impact">
            <div class="feature-icon-wrapper cyan">
              <el-icon size="32"><Connection /></el-icon>
            </div>
            <h2>网络传输支持</h2>
            <p>FastCopy 支持局域网内计算机间的快速文件传输，速度远超传统共享文件夹方式。支持 USB 设备、NAS、网络驱动器等，实现真正的跨平台文件传输。</p>
          </div>

          <!-- Feature 6: Statistics and Logs -->
          <div class="panel thirds impact">
            <div class="feature-icon-wrapper pink">
              <el-icon size="32"><DataLine /></el-icon>
            </div>
            <h2>详细传输统计</h2>
            <p>FastCopy 提供详细的传输统计信息，包括传输速度、剩余时间、文件数量等。支持传输日志记录，方便用户追踪和管理历史传输记录。</p>
          </div>
        </div>

        <div class="panel-container" style="margin-bottom:30px">
          <!-- Feature 7: Batch Operations -->
          <div class="panel thirds impact">
            <div class="feature-icon-wrapper yellow">
              <el-icon size="32"><List /></el-icon>
            </div>
            <h2>批量文件处理</h2>
            <p>FastCopy 支持批量文件处理，可以将多个文件或文件夹加入传输队列，按优先级顺序处理。支持队列管理，用户可以随时调整传输优先级。</p>
          </div>

          <!-- Feature 8: User-friendly Interface -->
          <div class="panel thirds impact">
            <div class="feature-icon-wrapper indigo">
              <el-icon size="32"><Operation /></el-icon>
            </div>
            <h2>简洁易用界面</h2>
            <p>FastCopy 提供直观的图形界面和强大的命令行版本。拖拽操作即可开始传输，支持自定义快捷键，提高工作效率。</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 为什么选择 FastCopy -->
    <div class="why-choose-section">
      <div class="container">
        <div class="why-choose-content">
          <div class="why-choose-icon">
            <el-icon size="48"><Cpu /></el-icon>
          </div>
          <h2>为什么选择 FastCopy?</h2>
          <p class="why-choose-desc">FastCopy 是全球最受欢迎的文件传输工具之一，功能强大。超过 1000 万用户的信赖选择，无论是大文件传输还是日常文件备份，FastCopy 都能提供最佳性能。</p>
          <div class="why-choose-features">
            <div class="feature-tag">
              <el-icon><TrendCharts /></el-icon>
              <span>极速传输</span>
            </div>
            <div class="feature-tag">
              <el-icon><Refresh /></el-icon>
              <span>持续更新</span>
            </div>
          </div>
          <el-button type="primary" size="large" class="cta-btn download-speed-btn" @click="downloadFastCopy">
            <el-icon><Download /></el-icon>
            <span class="btn-text">立即下载 FastCopy</span>
          </el-button>
        </div>
      </div>
    </div>

    <!-- 用户评价版块 -->
    <div class="reviews-section">
      <div class="container">
        <h2>用户评价</h2>
        <p class="section-subtitle">来自全球用户的真实好评</p>
        <div class="reviews-grid">
          <div class="review-card">
            <div class="review-header">
              <div class="reviewer-info">
                <div class="reviewer-avatar">👨‍💻</div>
                <div class="reviewer-name">李程序员</div>
              </div>
              <div class="review-stars">⭐⭐⭐⭐⭐</div>
            </div>
            <p class="review-text">"传输几十GB的代码仓库只需要几分钟，比系统复制快太多了！批量文件传输的首选工具。"</p>
          </div>

          <div class="review-card">
            <div class="review-header">
              <div class="reviewer-info">
                <div class="reviewer-avatar">📹</div>
                <div class="reviewer-name">王视频师</div>
              </div>
              <div class="review-stars">⭐⭐⭐⭐⭐</div>
            </div>
            <p class="review-text">"4K 视频文件传输速度惊人，断点续传功能让我再也不用担心网络中断了。"</p>
          </div>

          <div class="review-card">
            <div class="review-header">
              <div class="reviewer-info">
                <div class="reviewer-avatar">💼</div>
                <div class="reviewer-name">张经理</div>
              </div>
              <div class="review-stars">⭐⭐⭐⭐⭐</div>
            </div>
            <p class="review-text">"公司文件服务器备份的最佳工具，速度快又稳定，IT 部门的一致推荐。"</p>
          </div>

          <div class="review-card">
            <div class="review-header">
              <div class="reviewer-info">
                <div class="reviewer-avatar">🎮</div>
                <div class="reviewer-name">陈游戏迷</div>
              </div>
              <div class="review-stars">⭐⭐⭐⭐⭐</div>
            </div>
            <p class="review-text">"游戏安装包、MOD 文件传输神器，大大节省了我的游戏时间！"</p>
          </div>
        </div>
        <div class="review-stats">
          <div class="stat-item">
            <div class="stat-number">1000万+</div>
            <div class="stat-label">全球用户</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">4.9★</div>
            <div class="stat-label">平均评分</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">99%</div>
            <div class="stat-label">推荐率</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 中间 CTA 按钮区域 -->
    <div class="middle-cta-section">
      <div class="container">
        <h2>立即体验极速传输</h2>
        <p>加入 1000 万全球用户的行列，享受 10 倍传输速度提升</p>
        <div class="cta-buttons">
          <el-button type="primary" size="large" class="cta-btn" @click="downloadFastCopy">
            <el-icon><Download /></el-icon>
            立即免费下载
          </el-button>
          <el-button type="default" size="large" class="cta-btn-secondary" @click="scrollToFeatures">
            了解更多功能
          </el-button>
        </div>
      </div>
    </div>

    <!-- Try Free Section -->
    <div class="earnmoney tryforfreeblock">
      <div class="container">
        <h2>立即下载 FastCopy</h2>
        <p>传输速度提升 10 倍！FastCopy 支持大文件快速传输 + 断点续传功能，是程序员、设计师和所有需要文件传输的用户必备工具！</p>
        <el-button type="primary" size="large" class="cta-btn" @click="downloadFastCopy">
          <el-icon><Download /></el-icon>
          立即下载 FastCopy
        </el-button>
        <br><br>
        <div class="subtext">
          <img src="../assets/os.png" alt="FastCopy 系统支持"><br>
          支持系统：Windows XP/7/8/10/11 (绿色免安装)
        </div>
      </div>
    </div>
    
    <!-- 客服联系方式 -->
    <div class="customer-service">
      <div class="service-toggle" @click="toggleServicePanel">
        <el-icon><Service /></el-icon>
        <span>{{ isServicePanelOpen ? '收起客服' : '联系客服' }}</span>
      </div>
      <div class="service-content" :class="{ 'expanded': isServicePanelOpen }">
        <div class="service-header">
          <span>客服咨询</span>
        </div>
        <div class="service-body">
          <div class="service-info">
            <a href="https://work.weixin.qq.com/kfid/kfc8d0f9bc2d1044192" target="_blank" class="service-link">
              点击联系客服
            </a>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Footer -->
    <el-footer class="footer">
      <div class="footer-content">
        <div class="footer-main">
          <p class="copyright">Copyright©2025 信阳市平桥区奇安科技有限公司贵州分公司 黔ICP备2026000902号</p>
          <div class="footer-links">
            <a href="/#/fastcopy" class="footer-link">隐私政策</a>
            <span class="separator">|</span>
            <a href="/#/fastcopy" class="footer-link">用户协议</a>
            <span class="separator">|</span>
            <a href="/#/about" class="footer-link">联系我们</a>
          </div>
        </div>
        <div class="footer-disclaimer">
          <p><strong>免责声明：</strong>本网站的图文和软件资源来源于网络。若任何内容侵犯您的合法权益，请立即<a href="mailto:softdown51@outlook.com" class="disclaimer-link">与我们联系</a>，我们会在 24 小时内核实并删除。</p>
        </div>
      </div>
    </el-footer>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { 
  Download,
  Service,
  Lightning,
  Star,
  Refresh,
  TrendCharts,
  DocumentCopy,
  FolderOpened,
  DataLine,
  Connection,
  List,
  Operation,
  Cpu
} from '@element-plus/icons-vue'

// 路由相关
const route = useRoute()
const router = useRouter()

// 计算当前激活的菜单项
const activeMenu = computed(() => {
  if (route.path === '/order-query') {
    return '/order-query'
  } else if (route.path === '/about') {
    return '/about'
  } else if (route.path === '/fastcopy') {
    return '/fastcopy'
  } else if (route.path === '/feedback') {
    return '/feedback'
  }
  return '/'
})

// 菜单选择处理
const handleMenuSelect = (key) => {
  if (key === '/') {
    router.push('/')
  } else if (key === '/fastcopy') {
    router.push('/fastcopy')
  } else if (key === '/order-query') {
    router.push('/order-query')
  } else if (key === '/about') {
    router.push('/about')
  } else if (key === '/feedback') {
    router.push('/feedback')
  }
}

// 滚动到功能区域
const scrollToFeatures = () => {
  const featureBlock = document.querySelector('.featureblock')
  if (featureBlock) {
    featureBlock.scrollIntoView({ behavior: 'smooth' })
  }
}

// 下载 FastCopy
const downloadFastCopy = () => {
  // 模拟下载计数增加
  simulateDownload()
  
  // 发送Umami自定义事件 - FastCopy下载
  if (window.umami) {
    window.umami.track('download-fastcopy', {
      type: 'software',
      name: 'FastCopy',
      version: 'latest',
      url: 'https://file.51softdown.cn/download/fastcopy/FastCopy-Installer.exe'
    });
  }
  
  // 实际的下载逻辑
  window.open('https://file.51softdown.cn/download/fastcopy/FastCopy-Installer.exe', '_blank');
}

// 客服面板相关
const isServicePanelOpen = ref(false)

const toggleServicePanel = () => {
  isServicePanelOpen.value = !isServicePanelOpen.value
}

// 下载计数器相关
const downloadCount = ref(2156789) // 初始下载数
const isAnimating = ref(false)

// 模拟下载数增加
const simulateDownload = () => {
  const increment = Math.floor(Math.random() * 3) + 1 // 随机增加1-3次
  isAnimating.value = true
  
  // 动画效果
  setTimeout(() => {
    isAnimating.value = false
  }, 1000)
  
  // 增加下载数
  downloadCount.value += increment
}

// 定期模拟下载（每3-8秒随机增加）
const startDownloadSimulation = () => {
  const randomInterval = Math.floor(Math.random() * 5000) + 3000 // 3-8秒随机间隔
  setTimeout(() => {
    simulateDownload()
    startDownloadSimulation() // 递归调用，持续模拟
  }, randomInterval)
}

// 组件挂载时设置页面标题和 favicon
import { onMounted } from 'vue'

onMounted(() => {
  // 设置页面标题
  document.title = 'FastCopy 最新版下载 - 全球最快文件传输工具'
  
  // 设置 favicon
  let favicon = document.querySelector('link[rel="icon"]')
  if (favicon) {
    favicon.href = '/fastcopy.ico'
  } else {
    // 如果页面中没有 favicon link 标签，则创建一个
    favicon = document.createElement('link')
    favicon.rel = 'icon'
    favicon.href = '/fastcopy.ico'
    document.head.appendChild(favicon)
  }
  
  // 开始模拟下载
  startDownloadSimulation()
})
</script>

<style scoped>
.fastcopy-promotion-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #f0f8ff 0%, #e6f3ff 50%, #ffffff 100%);
}

/* Header Styles */
.header {
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 0;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 20px;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.logo:hover {
  transform: scale(1.05);
}

.logo-icon {
  width: 32px;
  height: 32px;
  object-fit: contain;
  display: block;
}

.logo-text {
  font-size: 20px;
  font-weight: 700;
  color: #3F414B;
  letter-spacing: 1px;
}

.nav-menu {
  border: none;
  background: transparent !important;
}

.nav-menu .el-menu-item {
  font-weight: 500;
  padding: 0 20px;
  font-size: 16px;
}

/* Main Banner */
.main-banner {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 80px 0;
  position: relative;
  overflow: hidden;
}

.main-banner::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at top right, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 1;
}

.hero-content {
  display: flex;
  align-items: center;
  gap: 60px;
}

.hero-text {
  flex: 1;
  max-width: 600px;
}

.hero-action-row {
  display: flex;
  align-items: center;
  gap: 20px;
  margin: 20px 0;
  flex-wrap: wrap;
}

.hero-action-row .cta-btn {
  margin-bottom: 0;
}

.hero-action-row .download-counter {
  margin: 0;
}

.hero-image {
  width: 100%;
  max-width: 400px;
  height: auto;
  /* border-radius: 12px; */
  /* box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3); */
  margin-bottom: 30px;
}

#comment-container {
  margin-bottom: 30px;
}

#comment1 {
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 25px;
  background: rgba(255, 255, 255, 0.1);
  padding: 20px;
  border-radius: 12px;
  backdrop-filter: blur(10px);
}

.hero-image-big {
  width: 100%;
  max-width: 450px;
  height: 530px;
  /* border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3); */
  object-fit: contain;
}

.cta-btn {
  background: linear-gradient(135deg, #ff6b6b, #ee5a52);
  border: none;
  border-radius: 50px;
  padding: 14px 28px;
  font-size: 15px;
  font-weight: 600;
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 15px;
  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.4);
  position: relative;
  overflow: hidden;
  height: 48px;
}

.cta-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s ease;
}

.cta-btn:hover::before {
  left: 100%;
}

.cta-btn:hover {
  transform: translateY(-3px) scale(1.02);
  box-shadow: 0 8px 25px rgba(255, 107, 107, 0.6);
  background: linear-gradient(135deg, #ff5252, #d32f2f);
}

.cta-btn:active {
  transform: translateY(-1px) scale(0.98);
}

.download-speed-btn {
  position: relative;
  overflow: hidden;
}

.download-speed-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s;
}

.download-speed-btn:hover::before {
  left: 100%;
}

.btn-text {
  font-weight: 600;
}

.download-counter {
  margin: 15px 0;
  padding: 12px 24px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.05));
  border-radius: 50px;
  backdrop-filter: blur(10px);
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  height: 48px;
  box-sizing: border-box;
}

.counter-label {
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
}

.counter-number {
  color: #ffd700;
  font-size: 18px;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.counter-animation {
  color: #4caf50;
  font-size: 13px;
  font-weight: 700;
  opacity: 0;
  transition: all 0.3s ease;
  background: rgba(76, 175, 80, 0.2);
  padding: 2px 8px;
  border-radius: 12px;
  margin-left: 4px;
}

.counter-animation.animate {
  opacity: 1;
  transform: translateY(-2px);
}

.system-requirements {
  margin: 15px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  opacity: 0.9;
}

.system-requirements img {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.download-benefits-info {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
  flex-wrap: wrap;
}

.download-benefits-info span {
  font-size: 0.9rem;
  font-weight: 500;
}

/* Feature Block */
.featureblock {
  padding: 80px 0;
  background: #f8fafe;
}

.panel-container {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
}

.panel {
  flex: 1;
  min-width: 300px;
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.panel:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.panel.impact {
  border-left: 4px solid #667eea;
  position: relative;
  overflow: hidden;
}

.panel.impact::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #667eea, #764ba2);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.panel.impact:hover::before {
  transform: scaleX(1);
}

.panel.highlight-panel {
  background: linear-gradient(135deg, #667eea15, #764ba215);
  border-left: 4px solid #ff6b6b;
}

/* Feature Icon Styles */
.feature-icon-wrapper {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  transition: all 0.3s ease;
}

.feature-icon-wrapper:hover {
  transform: scale(1.1) rotate(5deg);
}

.feature-icon-wrapper.blue {
  background: linear-gradient(135deg, #e3f2fd, #bbdefb);
  color: #1976d2;
}

.feature-icon-wrapper.green {
  background: linear-gradient(135deg, #e8f5e9, #c8e6c9);
  color: #388e3c;
}

.feature-icon-wrapper.orange {
  background: linear-gradient(135deg, #fff3e0, #ffe0b2);
  color: #f57c00;
}

.feature-icon-wrapper.purple {
  background: linear-gradient(135deg, #f3e5f5, #e1bee7);
  color: #7b1fa2;
}

.feature-icon-wrapper.cyan {
  background: linear-gradient(135deg, #e0f7fa, #b2ebf2);
  color: #00838f;
}

.feature-icon-wrapper.pink {
  background: linear-gradient(135deg, #fce4ec, #f8bbd9);
  color: #c2185b;
}

.feature-icon-wrapper.yellow {
  background: linear-gradient(135deg, #fffde7, #fff9c4);
  color: #f9a825;
}

.feature-icon-wrapper.indigo {
  background: linear-gradient(135deg, #e8eaf6, #c5cae9);
  color: #303f9f;
}

.feature-icon-wrapper.red {
  background: linear-gradient(135deg, #ffebee, #ffcdd2);
  color: #c62828;
}

.panel h2 {
  color: #2c3e50;
  font-size: 1.4rem;
  margin-bottom: 15px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
}

.panel p {
  color: #5a6c7d;
  line-height: 1.8;
  margin-bottom: 20px;
  font-size: 1rem;
}

.text-center {
  text-align: center;
}

.text-center img {
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

/* Why Choose Section */
.why-choose-section {
  padding: 100px 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  text-align: center;
}

.why-choose-content {
  max-width: 800px;
  margin: 0 auto;
}

.why-choose-icon {
  width: 100px;
  height: 100px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 30px;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.3);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 0 20px rgba(255, 255, 255, 0);
  }
}

.why-choose-section h2 {
  font-size: 2.8rem;
  margin-bottom: 25px;
  font-weight: 700;
  color: white;
}

.why-choose-desc {
  font-size: 1.2rem;
  line-height: 1.8;
  margin-bottom: 40px;
  opacity: 0.95;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

.why-choose-features {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
  margin-bottom: 40px;
}

.feature-tag {
  background: rgba(255, 255, 255, 0.15);
  padding: 12px 24px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.feature-tag:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
}

.why-choose-section .system-requirements {
  color: rgba(255, 255, 255, 0.8);
  margin-top: 20px;
}

/* Reviews Section */
.reviews-section {
  padding: 80px 0;
  background: white;
}

.reviews-section h2 {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 20px;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  position: relative;
  display: inline-block;
  left: 50%;
  transform: translateX(-50%);
}

.reviews-section h2::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 4px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 2px;
}

.section-subtitle {
  text-align: center;
  color: #7f8c8d;
  font-size: 1.2rem;
  margin-bottom: 60px;
  margin-top: 30px;
}

.reviews-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  margin-bottom: 60px;
}

.review-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafe 100%);
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.1);
  transition: all 0.3s ease;
  border: 1px solid rgba(102, 126, 234, 0.1);
  position: relative;
  overflow: hidden;
}

.review-card::before {
  content: '"';
  position: absolute;
  top: -10px;
  right: 20px;
  font-size: 80px;
  color: rgba(102, 126, 234, 0.1);
  font-family: Georgia, serif;
  line-height: 1;
}

.review-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 30px rgba(102, 126, 234, 0.2);
  border-color: rgba(102, 126, 234, 0.2);
}

.review-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.reviewer-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.reviewer-avatar {
  font-size: 2rem;
}

.reviewer-name {
  font-weight: 600;
  color: #2c3e50;
}

.review-stars {
  color: #ffc107;
  font-size: 1.2rem;
}

.review-text {
  color: #5a6c7d;
  line-height: 1.8;
  font-style: italic;
}

.review-stats {
  display: flex;
  justify-content: center;
  gap: 60px;
  margin-top: 40px;
}

.stat-item {
  text-align: center;
}

.stat-number {
  font-size: 2.5rem;
  font-weight: 700;
  color: #667eea;
  margin-bottom: 8px;
}

.stat-label {
  color: #7f8c8d;
  font-size: 1rem;
  font-weight: 500;
}

/* Middle CTA Section */
.middle-cta-section {
  padding: 80px 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  text-align: center;
}

.middle-cta-section h2 {
  font-size: 2.5rem;
  margin-bottom: 20px;
  font-weight: 600;
}

.middle-cta-section p {
  font-size: 1.3rem;
  margin-bottom: 40px;
  opacity: 0.9;
}

.cta-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.cta-btn-secondary {
  background: transparent;
  border: 2px solid white;
  color: white;
  border-radius: 50px;
  padding: 14px 30px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.cta-btn-secondary:hover {
  background: white;
  color: #667eea;
}

/* Awards Section */
.awardsblock {
  padding: 80px 0;
  background: #f8fafe;
  text-align: center;
}

.awardsblock h2 {
  color: #2c3e50;
  font-size: 2.5rem;
  margin-bottom: 60px;
  font-weight: 600;
}

.awards {
  display: flex;
  justify-content: center;
  gap: 40px;
  flex-wrap: wrap;
}

.award {
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.award:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
}

.awardimg img {
  height: 80px;
  width: auto;
  object-fit: contain;
}

.subtext {
  margin-top: 15px;
  color: #7f8c8d;
  font-weight: 500;
  font-size: 0.9rem;
}

/* Try Free Section */
.tryforfreeblock {
  padding: 80px 0;
  background: white;
  text-align: center;
}

.tryforfreeblock h2 {
  color: #2c3e50;
  font-size: 2.5rem;
  margin-bottom: 20px;
  font-weight: 600;
}

.tryforfreeblock p {
  color: #5a6c7d;
  font-size: 1.2rem;
  margin-bottom: 40px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

/* Customer Service */
.customer-service {
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
}

.service-toggle {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  text-align: center;
  padding: 12px 0;
  font-weight: bold;
  border-radius: 10px 10px 0 0;
  cursor: pointer;
  width: 180px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  font-size: 14px;
  letter-spacing: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.service-toggle:hover {
  background: linear-gradient(135deg, #764ba2, #667eea);
  box-shadow: 0 6px 24px rgba(102, 126, 234, 0.3);
  transform: translateY(-2px);
}

.service-content {
  background: white;
  border-radius: 0 0 10px 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  width: 180px;
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.3s ease;
}

.service-content.expanded {
  max-height: 300px;
}

.service-header {
  background: #667eea;
  color: white;
  text-align: center;
  padding: 10px 0;
  font-weight: bold;
}

.service-body {
  padding: 15px;
}

.service-info {
  text-align: center;
}

.service-info p {
  margin: 5px 0;
  font-size: 14px;
  color: #333;
}

.service-link {
  display: inline-block;
  background: #667eea;
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  text-decoration: none;
  font-size: 12px;
  margin-top: 5px;
  transition: background 0.3s;
}

.service-link:hover {
  background: #764ba2;
}

/* Footer */
.footer {
  background: #f8fafe;
  color: #666;
  text-align: center;
  padding: 30px 0 50px 0;
  height: auto !important;
  border-top: 1px solid #e6f3ff;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-main {
  margin-bottom: 20px;
}

.copyright {
  margin: 0 0 12px 0;
  font-size: 14px;
  color: #333;
}

.footer-links {
  display: flex;
  justify-content: center;
  gap: 30px;
  font-size: 12px;
  color: #999;
  flex-wrap: wrap;
}

.footer-link {
  color: #667eea;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-link:hover {
  color: #764ba2;
}

.separator {
  color: #ddd;
}

.footer-disclaimer {
  text-align: left;
  background: #f8fafe;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 20px;
}

.footer-disclaimer p {
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.8;
}

.disclaimer-link {
  color: #667eea;
  text-decoration: none;
}

.disclaimer-link:hover {
  text-decoration: underline;
}

/* Responsive Design */
@media (max-width: 768px) {
  .customer-service {
    display: none;
  }
  
  .hero-content {
    flex-direction: column;
    text-align: center;
    gap: 40px;
  }
  
  .hero-text {
    max-width: 100%;
  }
  
  .panel-container {
    flex-direction: column;
  }
  
  .reviews-grid {
    grid-template-columns: 1fr;
  }
  
  .review-stats {
    flex-direction: column;
    gap: 30px;
  }
  
  .awards {
    flex-direction: column;
    align-items: center;
  }
  
  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .footer-links {
    flex-direction: column;
    gap: 10px;
  }
  
  .download-benefits-info {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .hero-content {
    padding: 0 15px;
  }
  
  .panel-container {
    padding: 0 15px;
  }
  
  .container {
    padding: 0 15px;
  }
  
  .cta-btn {
    padding: 14px 24px;
    font-size: 14px;
  }
  
  .logo-text {
    font-size: 16px;
  }
  
  .hero-image-big {
    max-width: 100%;
  }
}
</style>